import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import courseOffering from '../../../proptypes/courses/courseOffering';
import AddRemoveCartButton from '../../shopping/AddRemoveCartButton';
import courseOfferingMethod from '../../../proptypes/courses/courseOfferingMethod';
import courseOfferingFormat from '../../../proptypes/courses/courseOfferingFormat';
import DropCourseButton from '../../inputs/DropCourseButton';
import SvgIcon from '../../icon/SvgIcon';
import PlayButton from '../../inputs/PlayButton';
import { connect } from 'react-redux';
import { shouldShowAsCompleted } from '../../../utilities/courseUtilities';
import { COURSE_SERIES } from "../../../constants/courseSeriesLookup";
import ReactPlaceholder from 'react-placeholder';

import * as courseSelectors from "../../../selectors/courseSelectors";
import registeredCourse from '../../../proptypes/users/registeredCourse';
import CourseDetailsHeaderPlaceHolder from '../../resources/placeholders/CourseDetailsHeaderPlaceHolder';
import { defaultCourseOffering } from '../../../store/initialState';
import LoadingSpinnerOverlay from '../../LoadingSpinnerOverlay';
import loadingStates from '../../../constants/loadingStates';

import { CONFIGURATION } from "../../../constants/config";

class CourseOfferingDetailHeader extends React.Component {
  render() {
    let { currentOffering, courseRegistration, history, loading,
      isLoadingRegistration } = this.props;
    let isLive = currentOffering.method === courseOfferingMethod.LIVE;
    let onDemand = currentOffering.method === courseOfferingMethod.ON_DEMAND;
    let isComplianceCourse = currentOffering.course.seriesId === COURSE_SERIES.COMPLIANCE_CONNECTIONS;
    let isSLAUniversityCourse = currentOffering.course.seriesId === COURSE_SERIES.SLA_UNIVERSITY;
    let isCourseCompleted = courseRegistration ? shouldShowAsCompleted(courseRegistration) : false;
    let isNonCeCourse =
    currentOffering.course.seriesId === COURSE_SERIES.COMPLIANCE_CONNECTIONS ||
      (onDemand && currentOffering.course.name === CONFIGURATION.INTRO_COURSE_NAME);

    const showPlaceholder = loading && currentOffering === defaultCourseOffering;

    return (
      <div className='detail-header-text'>
        <div className="header-left-col">
          <div className="row align-items-end">

            <div className="col-12 col-sm-11">

              <ReactPlaceholder showLoadingAnimation ready={!showPlaceholder} customPlaceholder={CourseDetailsHeaderPlaceHolder}>
                <div className='back-to-search'>
                  <span onClick={() => history.goBack()}>
                    <span className='svg-icon chevron-left'></span>
                    Return
                  </span>
                </div>                

                <h1 className='course-title'>
                  {currentOffering.course.name}
                </h1>

                <div className='row map-row'>
                  {isLive && (
                    <div className="course-sub-status card-header course-type">
                      <span>
                        <SvgIcon icon="cal" className='live-course' />
                      </span>
                      {currentOffering.format == courseOfferingFormat.WEBINAR && (
                        <span className='live-text'> LIVE WEBINAR </span>
                      )}
                      {currentOffering.format == courseOfferingFormat.IN_PERSON && (
                        <span className='live-text'> LIVE IN-PERSON </span>
                      )}
                    </div>
                  )}

                  {onDemand && (
                    <div className="course-sub-status card-header course-type">
                      <span>
                        <SvgIcon icon="play-screen" className='on-demand-course' />
                      </span>
                      <span className='on-demand-text'> ON DEMAND </span>
                    </div>
                  )}

                  {isNonCeCourse && (
                    <div className="course-sub-status card-header">
                      <span> COURSE NOT ELIGIBLE FOR CE CREDITS </span>
                    </div>
                  )}
                </div>
              </ReactPlaceholder>
            </div>
          </div>
        </div>

        <div className="detail-info">
          <div className='detail-info-items'>
            {courseRegistration ?
              <React.Fragment>
                {currentOffering.method === courseOfferingMethod.ON_DEMAND ?
                  <div className='detail-info-item'>
                    <PlayButton courseRegistration={courseRegistration} />
                  </div>
                  :
                  ''
                }
                {!isCourseCompleted &&
                  <div className='detail-info-item'>
                    <DropCourseButton courseRegistrationId={courseRegistration.id} />
                  </div>
                }
              </React.Fragment>
              :
              <LoadingSpinnerOverlay loading={isLoadingRegistration}>
                <div className='detail-info-item'>
                  <AddRemoveCartButton courseOffering={currentOffering} />
                </div>
              </LoadingSpinnerOverlay>
            }
            {isComplianceCourse &&
              <div className='detail-info-item'>
                <span className='detail-info-icon-container'>
                  <span className='svg-icon white compliance-connections'></span>
                </span>
              </div>
            }
            {isSLAUniversityCourse &&
              <div className='detail-info-item'>
                <span className='detail-info-icon-container'>
                  <span className='svg-icon white sla-university'></span>
                </span>
              </div>
            }            
          </div>
        </div>
      </div>
    );
  }
}

CourseOfferingDetailHeader.propTypes = {
  loading: PropTypes.bool,
  isLoadingRegistration: PropTypes.bool,
  history: PropTypes.object.isRequired,
  currentOffering: PropTypes.shape(courseOffering),
  courseRegistration: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape(registeredCourse)]),
  fullDescription: PropTypes.bool.isRequired,
  fullDescriptionClick: PropTypes.func.isRequired,
};

CourseOfferingDetailHeader.default = {
  fullDescription: false,
};

function mapStateToProps(state) {
  return {
    currentOffering: courseSelectors.selectCurrentCourseOffering(state),
    courseRegistration: courseSelectors.selectCourseRegistration(state),
    loading: courseSelectors.selectIsLoadingCourse(state),
    isLoadingRegistration: state.auth.isLoadingRegisteredCourses === loadingStates.LOADING,
  }
}

export default withRouter(connect(mapStateToProps)(CourseOfferingDetailHeader));
